export default "__VITE_ASSET__883195ee__"